var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout px-6 py-4"},[_vm._v(" Logout... ")])}
var staticRenderFns = []

export { render, staticRenderFns }